// index

let dt_index = null;
let dt_deliveries = null;

export function index(){

    dt_index = $('#certificate_requests_table').DataTable({
        ajax: {
            url: $('#certificate_requests_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_certificate_requests_actions },
            { width: '100', data: 'created_at', orderable: true, searchable: false, render: datatables.render_datetime },
            { width: '100', data: 'document', orderable: true, searchable: true },
            { width: '150', data: 'type', orderable: false, searchable: false },
            { data: 'reason', orderable: true, searchable: false, defaultContent: '' },
        ],
        order: [[2, 'desc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_requests"]').click(batch_delete_requests);
    });

    dt_index.on('draw', function(e, settings){
        // $(settings.nTableWrapper).find('.update_draft').click(update_draft);
    });

}

function batch_delete_requests(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['certificate_requests.batch_delete'];
    
    let certificate_requests_id = [];
    $.each(rows_selected, function(index, rowId){
        certificate_requests_id.push(rowId);
    });
    
    if(certificate_requests_id.length == 0){

        window.messages.error(__('No has seleccionado ninguna solicitud'));

    } else {

        const title = __('Eliminar solicitudes');
        const text = 
            trans_choice('{1} Estás a punto de eliminar una solicitud.|[2,*] Estás a punto de eliminar :count solicitudes.', certificate_requests_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    for(let certificate_request_id of certificate_requests_id){
                        formData.append('certificate_request_id[]', certificate_request_id);
                    }

                    window.ajax.post(route, formData);

                }, 
                _ => {}
            );

    }

}

function render_certificate_requests_actions(data, type, row){

    const url_info = ($("#certificate_requests_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

// create

export function create(){

    // $('select[name="document_type"]:not(.change-init)')
    //     .on('change', function(){
            
    //         if($(this).val() == '2'){
                
    //             $('.birthdate').show();
    //             $('.birthdate input').prop('required', true);

    //         } else {

    //             $('.birthdate').hide();
    //             $('.birthdate input').prop('required', false);
                
    //         }

    //     })
    //     .addClass('change-init');

    // $('select[name="document_type"]').trigger('change');
    $('.birthdate').removeClass('d-none');

}

// show

export function show(){

    dt_deliveries = $('#certificate_deliveries_table').DataTable({
        ajax: {
            url: $('#certificate_deliveries_table').attr('url'),
        },
        columns: [
            { width: '100', data: 'created_at', orderable: true, searchable: false, render: datatables.render_datetime },
            { width: '50', data: 'token', orderable: false, searchable: false },
            { width: '150', data: 'method', orderable: false, searchable: false },
            { data: 'receiver', orderable: false, searchable: false, defaultContent: '' },
            { width: '120', data: 'printed', orderable: false, searchable: false, render: datatables.render_datetime, defaultContent: '' },
        ],
        order: [[0, 'desc']],
    });

    dt_deliveries.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.filters-container').remove();
    });

    $('#modal_delivery select[name="method"]:not(.change-init)')
        .on('change', function(){
            
            switch($(this).val()){
                
                case 'sms':
                    
                    $('.method_sms').show();
                    $('.method_sms input[name="phone_prefix"]').val('34');
                    $('.method_sms input[name="phone"]').val('');
                    $('.method_sms input').prop('required', true);

                    $('.method:not(.method_sms)').hide();
                    $('.method:not(.method_sms) input').val('').prop('required', false);

                    break;

                case 'email':

                    $('.method_email').show();
                    $('.method_email input').prop('required', true);

                    $('.method:not(.method_email)').hide();
                    $('.method:not(.method_email) input').val('').prop('required', false);

                    break;

                default:

                    $('.method').hide();
                    $('.method input').val('').prop('required', false);

            }

        })
        .addClass('change-init');

    $('#new_delivery').click(function(){

        $('#modal_delivery input').val('');
        var first_method = $('#modal_delivery select[name="method"] option:first').attr('value');
        $('#modal_delivery select[name="method"]').val(first_method).trigger('change');

        $('#modal_delivery').modal('show');

    });

}

export function delivery_created(params){

    dt_deliveries.ajax.reload();
    $('#modal_delivery').modal('hide');

    if(params.certificate_delivery.method == 'ticket'){
        
        console.log('Print ticket with token ' + params.certificate_delivery.token);
        
        (async function(){

            await CefSharp.BindObjectAsync("boundAsync");
            boundAsync.print(params.certificate_delivery.token, params.qr).then(function(result){
                console.log("PRINT: ", result);    
            });

        })();

    }

}